export default {
  minYear: 1550,
  maxYear: 2030
}